(function () {
  const allowedUrls = ['/pages/womens-happy-hormone-pdp'];

  const currentPath = window.location.pathname.replace(/\/$/, '');

  const shouldRun = allowedUrls.some((url) => {
    const normalizedUrl = url.replace(/\/$/, '');
    return currentPath === normalizedUrl;
  });

  if (!shouldRun) return;

  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (!node.nodeValue.includes('†')) {
        return NodeFilter.FILTER_REJECT;
      }

      // Don't touch existing superscript
      if (node.parentElement?.closest('sup')) {
        return NodeFilter.FILTER_REJECT;
      }

      // Ignore these elements
      if (node.parentElement?.closest('script, style, textarea, input, noscript')) {
        return NodeFilter.FILTER_REJECT;
      }

      return NodeFilter.FILTER_ACCEPT;
    },
  });

  const nodes = [];

  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  }

  nodes.forEach((node) => {
    const parts = node.nodeValue.split('†');
    const fragment = document.createDocumentFragment();

    parts.forEach((part, index) => {
      if (part) {
        fragment.appendChild(document.createTextNode(part));
      }

      if (index < parts.length - 1) {
        const sup = document.createElement('sup');
        sup.textContent = '†';
        fragment.appendChild(sup);
      }
    });

    node.parentNode.replaceChild(fragment, node);
  });
})();
